export default [
  {
    content: "자율안전확인신고 및 안전검사 여부\n" +
      "※ 자율안전확인신고는 '13.3.1. 이후 제조·출고된 제품에 한함",
    isChecked: "",
  },
  {
    content: "로봇 방호장치 안전인증품 사용 여부 (안전매트, 광전자식 방호장치)\n" +
      "※안전인증 시행일 (’21.6.1.) 이후 해당",
    isChecked: "",
  },
  {
    content: "로봇 가동정지와 재가동 시 조작절차 준수 여부 확인",
    isChecked: "",
  },
  {
    content: "로봇 작동 반경 주변 1.8m 이상 울타리 및 안전매트, 광전자식 방호장치 등 방호장치 설치 유무",
    isChecked: "",
  },
  {
    content: "로봇 방호장치 무효화 사용 금지",
    isChecked: "",
  },
  {
    content: "로봇 수리·검사·청소 작업 시 Lock Out/Tag Out(LOTO) 조치등 잠금장치",
    isChecked: "",
  },
  {
    content: "로봇 수리·검사·청소 작업 시 작업중 표지판 부착",
    isChecked: "",
  },
  {
    content: "로봇의 조작방법 및 순서",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },
  {
    content: "작업 중의 매니퓰레이터 속도",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },
  {
    content: "2명 이상 근로자 작업 시킬 경우 신호방법",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },
  {
    content: "이상 발견한 경우 조치 방법",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },
  {
    content: "이상 발생시 로봇 정지 후 재가동 시킬 경우 조치",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },
  {
    content: "로봇의 예기치 못한 작동 또는 오조작에 의한 위험방지 조치",
    isChecked: "",
    title: "로봇 작업 시 아래 지침 작성 및 작업 준수",
  },



];
